import React from 'react';
import VersionDetailPanel from '../../../detail/VersionDetailPanel';
import InputForm from '../../../../../components/form/InputForm';
import { formRequiredRules } from '../../../../../lib/formRules';
import SelectForm from '../../../../../components/form/SelectForm';
import DateSinglePicker from '../../../../../components/datePicker/DateSinglePicker';
import BaseForm from '../../../../../components/form/BaseForm';
import TextAreaForm from '../../../../../components/form/TextAreaForm';
import CountOfTotal from '../../../../../components/CountOfTotal';
import Button from '../../../../../components/Button';
import { openNewWindow } from '../../../../../lib/common';
import {
  DATE_PICKER_VERSION_PLACEHOLDER_TEXT,
  MAXIMUM_NUMBER_OF_VERSION_MEMO_TEXT,
  VERSION_DETAIL_PAGE_PANEL_NAME,
  VERSION_FORCE_UPDATE_SELECT_LIST,
} from '../../../../../constants/service/app/versionConstants';
import { DATE_FORMAT } from '../../../../../constants/service/common/utilConstants';
import { REX_MILESTONE, REX_SERVICE_VERSION, REX_SPRINT, REX_URL, REX_VERSION } from '../../../../../lib/rex';
import { REQUIRED_MSG } from '../../../../../constants/service/common/formRulesConstants';
import './VersionDetailInfo.scss';

const VersionDetailInfo = (props) => {
  const { isEditable, form, setData, data } = props;
  const { serviceVer, code, forceUpdate, milestone, sprint, marketRegisterDate, releaseDate, jiraUrl, memo } = data;

  return (
    <VersionDetailPanel
      name={VERSION_DETAIL_PAGE_PANEL_NAME.VER_INFO}
      className="version-detail-info"
      title="서비스 정보"
    >
      <div className="panel-body">
        {/*서비스 버전*/}
        <InputForm
          label="버전"
          form={form}
          rules={[
            formRequiredRules(true, REQUIRED_MSG, false),
            { pattern: REX_SERVICE_VERSION, message: '유효한 버전이 아닙니다.' },
          ]}
          isEditable={isEditable}
          initialValue={serviceVer}
          onChange={(value) =>
            setData({
              path: ['versionDetail', 'verInfo', 'serviceVer'],
              value,
            })
          }
          name="serviceVer"
          size="large"
          placeholder="1.1.3"
          subContent={
            <div className="sub-info">
              <div>[숫자.숫자.숫자] 이 형식만 유효합니다. 1.1.1(O) / 0.1.11(O) / 1.1.1.1(O) / 일.(X)</div>
            </div>
          }
        />

        {/*버전코드*/}
        <InputForm
          label="버전 코드"
          form={form}
          rules={[
            formRequiredRules(true, REQUIRED_MSG, false),
            { pattern: REX_VERSION, message: '유효한 버전 코드가 아닙니다.' },
          ]}
          isEditable={isEditable}
          initialValue={code}
          onChange={(value) =>
            setData({
              path: ['versionDetail', 'verInfo', 'code'],
              value,
            })
          }
          name="code"
          size="large"
          placeholder="675"
          subContent={
            <div className="sub-info">
              <div>주의사항: 안드로이드와 ios는 버전 체계가 다릅니다.</div>
            </div>
          }
        />

        {/*강제 업데이트 여부*/}
        <SelectForm
          label="강제 업데이트 여부"
          form={form}
          isTable
          rules={[formRequiredRules(true, REQUIRED_MSG, false)]}
          isEditable={isEditable}
          initialValue={forceUpdate}
          onChange={(value) =>
            setData({
              path: ['versionDetail', 'verInfo', 'forceUpdate'],
              value,
            })
          }
          name="forceUpdate"
          list={VERSION_FORCE_UPDATE_SELECT_LIST}
        />

        {/*마일스톤*/}
        <InputForm
          label="마일스톤"
          form={form}
          rules={[
            formRequiredRules(true, REQUIRED_MSG, false),
            { pattern: REX_MILESTONE, message: '유효한 마일스톤이 아닙니다.' },
          ]}
          isEditable={isEditable}
          initialValue={milestone}
          onChange={(value) =>
            setData({
              path: ['versionDetail', 'verInfo', 'milestone'],
              value,
            })
          }
          name="milestone"
          size="large"
          placeholder="M5"
          subContent={
            <div className="sub-info">
              <div>[M숫자] 이 형식만 유효합니다. M5(O), M23(O), 1M3(X), FM4(X)</div>
            </div>
          }
        />

        {/*스프린트*/}
        <InputForm
          label="스프린트"
          form={form}
          rules={[
            formRequiredRules(true, REQUIRED_MSG, false),
            { pattern: REX_SPRINT, message: '유효한 스프린트가 아닙니다.' },
          ]}
          isEditable={isEditable}
          initialValue={sprint}
          onChange={(value) =>
            setData({
              path: ['versionDetail', 'verInfo', 'sprint'],
              value,
            })
          }
          name="sprint"
          size="large"
          placeholder="S56"
          subContent={
            <div className="sub-info">
              <div>[S숫자] 이 형식만 유효합니다. S5(O), S23(O), 1S3(X), RS4(X)</div>
            </div>
          }
        />

        {/*마켓에 등록한 날짜*/}
        <BaseForm
          label="마켓에 등록한 날짜"
          content={
            <DateSinglePicker
              value={marketRegisterDate}
              outFormat={DATE_FORMAT.FULL_DASH_FORMAT}
              btnTextFormat={DATE_PICKER_VERSION_PLACEHOLDER_TEXT}
              format={DATE_FORMAT.FULL_DASH_FORMAT}
              onSelect={(value) =>
                setData({
                  path: ['versionDetail', 'verInfo', 'marketRegisterDate'],
                  value,
                })
              }
              showTime={{
                format: DATE_FORMAT.FULL_DASH_FORMAT,
              }}
            />
          }
        />

        {/*릴리즈 된 날짜*/}
        <BaseForm
          label="릴리즈 된 날짜"
          content={
            <DateSinglePicker
              value={releaseDate}
              outFormat={DATE_FORMAT.FULL_DASH_FORMAT}
              btnTextFormat={DATE_PICKER_VERSION_PLACEHOLDER_TEXT}
              format={DATE_FORMAT.FULL_DASH_FORMAT}
              onSelect={(value) =>
                setData({
                  path: ['versionDetail', 'verInfo', 'releaseDate'],
                  value,
                })
              }
              showTime={{
                format: DATE_FORMAT.FULL_DASH_FORMAT,
              }}
            />
          }
        />

        {/*Jira 주소*/}
        <InputForm
          label="Jira 주소"
          className="jira-url"
          form={form}
          initialValue={jiraUrl}
          isEditable={isEditable}
          rules={[
            formRequiredRules(false, '공백만 들어갈 수 없습니다.'),
            { pattern: REX_URL, message: '유효한 주소가 아닙니다.' },
          ]}
          placeholder="http://jira.bejewel.co.kr/browse/AMZAWEB-322"
          onChange={(value) =>
            setData({
              path: ['versionDetail', 'verInfo', 'jiraUrl'],
              value,
            })
          }
          name="jiraUrl"
          size="large"
          style={{ width: 500 }}
          subContent={
            <div className="sub-info">
              <span>주소 형식만 유효합니다.</span>
              {/*유효한 주소 형식일때만 버튼 보여주기*/}
              {REX_URL.test(jiraUrl) ? (
                <Button isRadius color="primary" text="입력 된 주소로 이동" onClick={() => openNewWindow(jiraUrl)} />
              ) : null}
            </div>
          }
        />

        {/*메모*/}
        <TextAreaForm
          form={form}
          label={
            <span>
              메모
              <CountOfTotal content={memo} maxCnt={MAXIMUM_NUMBER_OF_VERSION_MEMO_TEXT} />
            </span>
          }
          rules={[formRequiredRules(false, '공백만 들어갈 수 없습니다.')]}
          initialValue={memo}
          isEditable={isEditable}
          placeholder="메모할 내용을 적어주세요."
          maxLength={MAXIMUM_NUMBER_OF_VERSION_MEMO_TEXT}
          onChange={(value) =>
            setData({
              path: ['versionDetail', 'verInfo', 'memo'],
              value,
            })
          }
          name="memo"
          size="large"
          rows={2}
          subContent={
            <div className="sub-info">
              <div>최대 2000자 까지 가능합니다</div>
            </div>
          }
        />
      </div>
    </VersionDetailPanel>
  );
};

export default VersionDetailInfo;
